import { useEffect } from "react";
import { showLoader } from "utils/helper";
import { toast } from "react-toastify";
import { StudentDocumentsSuccessPayload } from "store/studentDashboard/types";
import { studentDocumentsRequest } from "store/studentDashboard/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { AppRoutings } from "utils/enums/app-routings";

const EducatorHandbook: React.FC = () => {
  const history = useHistory();
  const onEducatorHandBookPreviewSuccess = (
    response: StudentDocumentsSuccessPayload
  ) => {
    if (response.document !== null) {
      const url = response.document;
      window.open(url, "_blank");
      history.push(AppRoutings.EducatorsDashboard);
    } else {
      toast.success("Educator Handbook will be available soon");
    }
  };
  const dispatch = useDispatch();
  const handleEducatorHandBookPreview = () => {
    if (studentDocumentsRequest) {
      showLoader();
      const payload = {
        values: {
          type: "EducatorHandBook",
        },
        callback: onEducatorHandBookPreviewSuccess,
      };
      dispatch(studentDocumentsRequest(payload));
    }
  };
  useEffect(() => {
    handleEducatorHandBookPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default EducatorHandbook;
